import { Button } from '@/components/ui/button';
import React from 'react';
import { DialogType, TooltipType, VariantType } from '@/types';
import { DrawerType } from '@/types/ui/drawer.types';
import { BaseUIKitWrapper } from '../shared/BaseUIKitWrapper';
import { cn } from '@/lib/utils';

interface IconButtonProps {
  icon: any;
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  isActive?: boolean;
  tooltip?: TooltipType;
  label?: string;
  dialog?: DialogType;
  drawer?: DrawerType;
  href?: string;
  id?: string;
  classNames?: { icon?: string; button?: string };
  variant?: VariantType;
  showLabel?: boolean;
  disabled?: boolean;
  children?: React.ReactNode;
  dataTestid?: string;
}

export const BaseIconButton = ({
  icon,
  onClick,
  isActive = false,
  tooltip,
  dialog,
  drawer,
  variant,
  label,
  classNames,
  showLabel,
  disabled,
  dataTestid,
}: IconButtonProps) => {
  // Check if icon is already a React element or a component
  const iconElement = React.isValidElement(icon) 
    ? React.cloneElement(icon as React.ReactElement, {
        className: cn('scale-[1.5]', classNames?.icon, (icon as React.ReactElement).props?.className)
      })
    : React.createElement(icon, { className: cn('scale-[1.5]', classNames?.icon) });

  return (
    <BaseUIKitWrapper tooltip={tooltip} drawer={drawer} dialog={dialog}>
      <Button
        disabled={disabled}
        variant={variant}
        size="icon"
        onClick={onClick}
        className={cn(
          ' min-h-11 min-w-11 ',
          ` ${isActive ? 'bg-gradient-to-br from-[#6667DD] to-[#12FFE2] rounded-full text-black' : ''}`,
          `${classNames?.button}`
        )}
        {...(dataTestid ? { 'data-testid': dataTestid } : {})}
      >
        {iconElement}
        {showLabel && <div className="whitespace-pre-line text-sm">{label}</div>}
      </Button>
    </BaseUIKitWrapper>
  );
};
